import { IsNotEmpty, IsString, IsUUID } from 'class-validator';

export class AddParticipantDto {
  @IsNotEmpty()
  @IsUUID()
  eventTypeId: string;

  @IsNotEmpty()
  @IsUUID()
  companyId: string;

  @IsString({ groups: ['form', 'submit'] })
  @IsNotEmpty({
    message: 'Выберите участника',
    groups: ['form', 'submit'],
  })
  @IsUUID()
  groupId: string;
}
